import type { TextareaDesignTokens, TextareaTokenSections } from '@primeuix/themes/types/textarea';

export const root: TextareaTokenSections.Root = {
    background: '{formField.background}',
    disabledBackground: '{formField.disabledBackground}',
    filledBackground: '{formField.filledBackground}',
    filledHoverBackground: '{formField.filledHoverBackground}',
    filledFocusBackground: '{formField.filledFocusBackground}',
    borderColor: '{formField.borderColor}',
    hoverBorderColor: '{formField.hoverBorderColor}',
    focusBorderColor: '{formField.focusBorderColor}',
    invalidBorderColor: '{formField.invalidBorderColor}',
    color: '{formField.color}',
    disabledColor: '{formField.disabledColor}',
    placeholderColor: '{formField.placeholderColor}',
    invalidPlaceholderColor: '{formField.invalidPlaceholderColor}',
    shadow: '{formField.shadow}',
    paddingX: '{formField.paddingX}',
    paddingY: '{formField.paddingY}',
    borderRadius: '{formField.borderRadius}',
    focusRing: {
        width: '{formField.focusRing.width}',
        style: '{formField.focusRing.style}',
        color: '{formField.focusRing.color}',
        offset: '{formField.focusRing.offset}',
        shadow: '{formField.focusRing.shadow}'
    },
    transitionDuration: '{formField.transitionDuration}',
    sm: {
        fontSize: '{formField.sm.fontSize}',
        paddingX: '{formField.sm.paddingX}',
        paddingY: '{formField.sm.paddingY}'
    },
    lg: {
        fontSize: '{formField.lg.fontSize}',
        paddingX: '{formField.lg.paddingX}',
        paddingY: '{formField.lg.paddingY}'
    }
};

export default {
    root
} satisfies TextareaDesignTokens;
